module.exports = __webpack_public_path__ + "img/topbar_right_arrow.94692c9df2101b2aba40665b570fec96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topbar_right_arrow.png
// module id = 739
// module chunks = 0